<!--
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2025-11-28 10:35:27
 * @LastEditors: Tang Hao
 * @LastEditTime: 2026-01-07 19:04:02
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import RiskRuleForm from '@/found/views/risk/views/risk_management/risk_rule/form';
import {
  clickVisible,
  operateRiskRule,
} from '@/found/views/risk/views/risk_management/risk_rule/actions';
import Form from './form';
import DifferentFormTable from './form/DifferentFormTable.vue';
import FundDetails from './form/fund_details';

export default {
  extends: TablePage,
  components: {
    Form,
    DifferentFormTable,
    FundDetails,
    RiskRuleForm,
  },
  data() {
    return {
      requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('main_list');
  },
  methods: {
    isExtendsFn(item) {
      if (item && ['add', 'enable', 'disable'].includes(item.code || item.buttonCode)) {
        return false;
      }
      return TablePage.methods.isExtendsFn.call(this, item);
    },

    modalClick({ val, row }) {
      if (val.code === 'add') {
        this.formName = 'RiskRuleForm';
        this.formConfig = {
          ...this.formConfig,
          code: 'add',
          row: row || {},
          formFunctionCode: val.doCode || val.formFunctionCode || 'risk_rule_form',
        };
        this.modalConfig.title = val.name || val.buttonName || '新增风控规则';
        this.openFull();
        return;
      }

      if (val.code === 'enable' || val.code === 'disable') {
        this.operationClick(val.code, row);
        return;
      }

      if (val.code === 'reconciliation') {
        this.formName = 'Form';
        this.formConfig = {
          ...this.formConfig,
          code: 'add',
          row,
        };
        this.modalConfig.title = '对账';
        this.openModal();
      }
      if (val.code === 'view_differences') {
        this.formName = 'DifferentFormTable';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '查看差异项';
        this.openFull();
      }
      if (val.code === 'fund_details') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '资金明细';

        this.formName = 'FundDetails';
        this.openFull();
      }
    },

    operationClick(code, row) {
      return operateRiskRule({
        code,
        row,
        selection: this.selection,
        request,
        onEmpty: () => this.$message({ type: 'error', message: '请选择数据' }),
        onSuccess: () => {
          this.$message({ type: 'success', message: `${code === 'enable' ? '启用' : '禁用'}成功` });
          this.selection = [];
          this.selectRow = [];
          this.getList();
        },
      });
    },

    clickVisible,
  },
};
</script>
